var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    dedent = _require$doc$builders.dedent,
    group = _require$doc$builders.group,
    indent = _require$doc$builders.indent,
    join = _require$doc$builders.join,
    line = _require$doc$builders.line;

var functionName = function functionName(node) {
  if (node.isConstructor && !node.name) return 'constructor';
  if (node.name) return "function ".concat(node.name);
  return 'function';
};

var visibility = function visibility(node) {
  if (node.visibility && node.visibility !== 'default') {
    return concat([line, node.visibility]);
  }

  return '';
};

var stateMutability = function stateMutability(node) {
  if (node.stateMutability && node.stateMutability !== 'default') {
    return concat([line, node.stateMutability]);
  }

  return '';
};

var modifiers = function modifiers(node, path, print) {
  if (node.modifiers.length > 0) {
    return concat([line, join(line, path.map(print, 'modifiers'))]);
  }

  return '';
};

var returnParameters = function returnParameters(node, path, print) {
  if (node.returnParameters) {
    return concat([line, 'returns (', path.call(print, 'returnParameters'), ')']);
  }

  return '';
};

var signatureEnd = function signatureEnd(node) {
  if (node.body) return dedent(line);
  return ';';
};

var body = function body(node, path, print) {
  if (node.body) return path.call(print, 'body');
  return '';
};

var FunctionDefinition = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    return concat([functionName(node), '(', path.call(_print, 'parameters'), ')', indent(group(concat([visibility(node), stateMutability(node), modifiers(node, path, _print), returnParameters(node, path, _print), signatureEnd(node)]))), body(node, path, _print)]);
  }
};
module.exports = FunctionDefinition;